import React from 'react';
import { useAtomValue } from 'jotai';
import { authState } from '../store/atoms';
import { Teacher, User } from '../types/api';
import { getLessonTypeLabel } from '../utils/formatters';
import { getWeekdayLabel } from '../utils/formatters/labels';

interface TeacherPageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode; // 타이틀과 사용자 정보 사이에 들어가는 컨트롤 영역
}

// 페이지 공통 상단 헤더 바 (네이비 프로 시안) — 선생님/학생 공용
const TeacherPageHeader: React.FC<TeacherPageHeaderProps> = ({ title, subtitle, children }) => {
  const auth = useAtomValue(authState);
  const isTeacher = auth.userType === 'teacher';
  const name = auth.userInfo?.name;

  // 시안: 학생은 "이서연 · 성인 1:1 · 화/목" 형식
  const student = !isTeacher ? (auth.userInfo as User | undefined) : undefined;
  const studentInfo = student
    ? [
        student.lessonType ? getLessonTypeLabel(student.lessonType) : null,
        student.lessonDayOfWeek ? getWeekdayLabel(student.lessonDayOfWeek) : null,
      ].filter(Boolean).join(' · ')
    : '';
  const roleLabel = isTeacher
    ? ((auth.userInfo as Teacher | undefined)?.role === 'admin' ? '원장' : '선생님')
    : (studentInfo || '수강생');

  return (
    <div className="teacher-page-header">
      <h1 className="page-title">{title}</h1>
      {subtitle && <span className="page-subtitle">{subtitle}</span>}
      {children && <div className="header-controls">{children}</div>}
      {name && (
        <div className="page-user">
          {name} <span className="page-user-role">· {roleLabel}</span>
        </div>
      )}
    </div>
  );
};

export default TeacherPageHeader;
